import { render, staticRenderFns } from "./FinanceRevenueArrChart.vue?vue&type=template&id=84a819f2&scoped=true&"
import script from "./FinanceRevenueArrChart.vue?vue&type=script&lang=js&"
export * from "./FinanceRevenueArrChart.vue?vue&type=script&lang=js&"
import style0 from "./FinanceRevenueArrChart.vue?vue&type=style&index=0&id=84a819f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a819f2",
  null
  
)

export default component.exports